import { useQuery } from "@tanstack/react-query";
import { QUERY_KEYS } from "@/constants/QUERY_KEYS";
import httpClient from "@/config/axios";

/** `/contact/list` 단일 아이템 스펙 (서버 실데이터 기준) */
export type ContactItem = {
  No: number;
  Tel: string;
  Writer: string;
  WriterID: string;
  context: string;
  filename: string | null;
  jobState: string; // "접수" | "완료"
  replycontent: string;
  title: string;
  wEmail: string;
  writeDate: string;
  Manager?: string;
  Comment?: string;
};

/**
 * 문의 내역 목록을 가져오는 커스텀 훅
 * @param page 페이지 번호
 * @param pagesize 페이지 크기
 * @returns useQuery 결과
 */
export function useContactList(page: number = 1, pagesize: number = 10) {
  return useQuery({
    queryKey: QUERY_KEYS.contact.list(page, pagesize),
    queryFn: async () => {
      return await httpClient.get<ContactItem[]>("/contact/list", {
        params: { page, pagesize },
      });
    },
  });
}
